<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event"></app-employee-header>

    <app-benefit-details-standard
        *ngIf="!showSimplyBenefitsCard"
        (isLoading)="isLoading = $event"
    ></app-benefit-details-standard>

    <app-benefit-details-simply-benefits
        *ngIf="showSimplyBenefitsCard"
        (isLoading)="isLoading = $event"
    ></app-benefit-details-simply-benefits>
</div>
